import store from '..';

export const states = {
  namespaced: true,
  state: {
    isApplicationStateInitiated: false
  },
  getters: {
    getIsApplicationStateInitiated: (state: any) => {
        return state.isApplicationStateInitiated;
    },
  },
  actions: {
    clear({ commit }: any) {
        commit("clear");
    },
    initStates({ dispatch, commit }: any) {
        return new Promise(async (resolve, reject) => {
            if (!store.getters["states/getIsApplicationStateInitiated"]) {
                await dispatch("childcare/getChildcareEnrollmentSteps", null, { root: true })
                    .catch((error: any) => {
                        console.log(error);
                        
                        reject(false);
                    });

                await dispatch("childcare/getProviderForCurrentUser", null, { root: true })
                    .catch((error: any) => {
                        console.log(error);
                        
                        reject(false);
                    });
            
                await dispatch("booking/getBookingStatus", null, { root: true })
                    .catch((error: any) => {
                        console.log(error);
                        
                        reject(false);
                    });

                await dispatch("childcare/getNotifications", null, { root: true })
                    .catch((error: any) => {
                        console.log(error);

                        reject(false);
                    });
            
                await dispatch("booking/getProviders", null, { root: true })
                    .catch((error: any) => {
                        console.log(error);
                        
                        reject(false);
                    });

                await dispatch("auth/getUserInfo", null, { root: true })
                    .catch((error: any) => {
                        console.log(error);
                        
                        reject(false);
                    });

                await dispatch("child/getChildren", null, { root: true })
                    .catch((error: any) => {
                        console.log(error);
                        
                        reject(false);
                    });

                commit('setIsApplicationStateInitiated', true);
            }

            resolve(true);
        });
    },    
    setIsApplicationStateInitiated({ commit }: any, isApplicationStateInitiated: boolean) {
        commit("setIsApplicationStateInitiated", isApplicationStateInitiated);
    },
  },
  mutations: {
    clear(state: any) {
        state.isApplicationStateInitiated = false;
    },
    setIsApplicationStateInitiated(state: any, isApplicationStateInitiated: boolean) {
        state.isApplicationStateInitiated = isApplicationStateInitiated;
    },
  }
};

export default states;